import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import { getAdjustmentApi } from '../../utils/apisConsts';
import DeleteDebitAndCreditForm from './deleteDebitAndCreditForm';

class DeleteDebitAndCredit extends Component {
    state = {
        componentSteps: [
            {
                title: 'Request ID',
                content: <GetInfo isAdjustment placeHolder="Enter Request ID" apiLink={getAdjustmentApi}/>,
                id: 0,
            }, {
                title: 'Delete Debit/Credit',
                content: <DeleteDebitAndCreditForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default DeleteDebitAndCredit